/* Quote list store, shared by both stores (2026-09-28).
 * Two lists, one quote: Piobox lines live in piobox:quote:v1 (written by pbq-pdp.js on the
 * Piobox product page), BLANKD lines stay in blankd:quote:v1 (written by blankd-product.js,
 * unchanged). The quote page (pbq-quote.js) reads both and keeps them visibly apart.
 * Paints every quote badge on the page with the combined line count. */
(() => {
  if (window.PBQ) return;
  const KEYS = { pb: "piobox:quote:v1", bk: "blankd:quote:v1" };
  const load = (b) => { try { const v = JSON.parse(localStorage.getItem(KEYS[b])); return Array.isArray(v) ? v : []; } catch { return []; } };
  const save = (b, list) => {
    try { localStorage.setItem(KEYS[b], JSON.stringify(list)); return true; }
    catch {
      // Quota: mock-ups are the heavy part. Drop the oldest images first rather than lose a line.
      try {
        const lite = list.map((l, i) => (i < list.length - 1 ? { ...l, image: "" } : l));
        localStorage.setItem(KEYS[b], JSON.stringify(lite));
        return true;
      } catch { return false; }
    }
  };
  const count = () => load("pb").length + load("bk").length;
  // Piobox nav's "Get a quote" pill gets a count badge (BLANKD's header ships its own).
  const badge = () => {
    document.querySelectorAll(".pbx-nav__quote").forEach((a) => {
      if (a.querySelector("[data-pbx-quote-count]")) return;
      const s = document.createElement("span");
      s.className = "pbq-badge";
      s.setAttribute("data-pbx-quote-count", "");
      s.hidden = true;
      a.appendChild(s);
    });
    if (!document.getElementById("pbq-badge-css")) {
      const st = document.createElement("style");
      st.id = "pbq-badge-css";
      st.textContent = ".pbx-nav__quote{position:relative}.pbq-badge{display:inline-grid;place-items:center;min-width:20px;height:20px;padding:0 6px;border-radius:999px;background:#F0531C;color:#fff;font:700 11px/1 \"Geist\",Arial,sans-serif}.pbq-badge[hidden]{display:none}@media (max-width:1080px){.pbq-badge{position:absolute;top:-4px;right:-4px}}";
      document.head.appendChild(st);
    }
  };
  const paint = () => {
    badge();
    const n = count();
    document.querySelectorAll("[data-pbx-quote-count],[data-bdn-quote-count]").forEach((el) => {
      el.textContent = n ? String(n) : "";
      el.dataset.count = n;
      el.hidden = !n && el.hasAttribute("data-pbx-quote-count");
    });
  };
  const changed = () => { paint(); document.dispatchEvent(new CustomEvent("pbq:change", { detail: { count: count() } })); };
  const add = (b, line) => { const l = load(b); l.push(line); const ok = save(b, l); changed(); return ok; };

  window.PBQ = { KEYS, load, save, add, count, changed, paint };

  // blankd-header.js paints its badge with the BLANKD list only; running after it (next tick)
  // keeps the badge on the combined count.
  const later = () => setTimeout(paint, 0);
  document.addEventListener("DOMContentLoaded", later);
  window.addEventListener("pageshow", later);
  window.addEventListener("storage", (e) => { if (e.key === KEYS.pb || e.key === KEYS.bk) { later(); document.dispatchEvent(new CustomEvent("pbq:change")); } });
  if (document.readyState !== "loading") later();
})();
